// extracted by mini-css-extract-plugin
var _1 = "PostViewError-module__animatedBackground--QHkYb";
var _2 = "PostViewError-module__background--qoB_F";
var _3 = "PostViewError-module__buttons--E12Rc";
var _4 = "PostViewError-module__container--Lt17J";
var _5 = "PostViewError-module__content--djKpY";
var _6 = "PostViewError-module__inner--Nbzth";
var _7 = "PostViewError-module__logo--mD5Xy";
var _8 = "PostViewError-module__message--WSyt2";
var _9 = "PostViewError-module__requestAccessButton--OGV0D";
var _a = "PostViewError-module__title--jFbQ3";
export { _1 as "animatedBackground", _2 as "background", _3 as "buttons", _4 as "container", _5 as "content", _6 as "inner", _7 as "logo", _8 as "message", _9 as "requestAccessButton", _a as "title" }
